<section class="pea" [style.--pea-primary]="primaryColor">
  <div class="pea-wrap">
    <header class="pea-topo">
      <div>
        <p class="pea-kicker">Minha conta</p>
        <h1>Seus pedidos</h1>
        <p class="pea-sub">
          {{ lista.length }} de {{ totalElements }} pedidos encontrados
        </p>
      </div>
      <div class="pea-busca">
        <div class="pea-busca-campo" [class.has-clear]="!!(clienteFiltro || searchTerm)">
          <i class="bi bi-search"></i>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            placeholder="Buscar por nº do pedido ou cliente"
            (keyup.enter)="onSearch()"
            (input)="fecharBuscaClientes()"
          />
          <button
            *ngIf="clienteFiltro || searchTerm"
            type="button"
            class="pea-busca-limpar"
            (click)="limparCliente($event)"
            aria-label="Limpar busca"
            title="Limpar busca"
          >
            ×
          </button>
          <div class="pea-busca-drop" *ngIf="buscandoCliente || buscaClientes.length">
            <div *ngIf="buscandoCliente" class="pea-busca-load">Buscando clientes...</div>
            <button
              type="button"
              *ngFor="let c of buscaClientes"
              (click)="selecionarClienteBusca(c)"
            >
              <strong>{{ nomeClienteBusca(c) }}</strong>
              <em *ngIf="docClienteBusca(c)">{{ docClienteBusca(c) }}</em>
            </button>
          </div>
        </div>
        <button type="button" class="pea-busca-btn" (click)="onSearch()">
          Buscar
        </button>
      </div>
    </header>

    <section class="pea-filtros">
      <div class="pea-chips">
        <button
          type="button"
          *ngFor="let chip of chips; trackBy: trackChip"
          class="pea-chip"
          [class.ativo]="ehStatusAtivo(chip.id)"
          (click)="filtrarStatus(chip.id)"
        >
          {{ chip.label }}
          <span>{{ chip.count }}</span>
        </button>
      </div>
      <select
        [(ngModel)]="selectedPeriod"
        (change)="onPeriodChange()"
        class="pea-periodo"
      >
        <option value="30d">Últimos 30 dias</option>
        <option value="3m">Últimos 3 meses</option>
        <option value="6m">Últimos 6 meses</option>
        <option value="1a">Último ano</option>
      </select>
    </section>

    <div *ngIf="loading" class="pea-loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>

    <div *ngIf="empty && !loading" class="pea-vazio">
      <i class="bi bi-box-seam"></i>
      <p>Nenhum pedido encontrado</p>
      <small>Tente outro status ou termo de busca.</small>
    </div>

    <div *ngIf="!empty && !loading" class="pea-lista">
      <article *ngFor="let p of lista" class="pea-card">
        <div class="pea-card-topo">
          <div class="pea-card-meta">
            <div class="pea-id">
              <span class="pea-icone"><i class="bi bi-box-seam"></i></span>
              <div>
                <small>Pedido nº</small>
                <strong>#{{ p.numero_pedido || p.id }}</strong>
              </div>
            </div>
            <span class="pea-sep"></span>
            <div class="pea-campo">
              <i class="bi bi-building"></i>
              <div>
                <small>Cliente</small>
                <strong>{{ getClienteNome(p) }}</strong>
                <em *ngIf="getClienteCnpj(p)">{{ getClienteCnpj(p) }}</em>
              </div>
            </div>
            <span class="pea-sep"></span>
            <div class="pea-campo">
              <i class="bi bi-tag"></i>
              <div>
                <small>Tipo do pedido</small>
                <span class="pea-tipo">{{ getTipoPedido(p) }}</span>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="pea-status"
            [ngClass]="classeStatus(getStatusPedido(p))"
            (click)="filtrarStatusDoCard(p)"
          >
            {{ statusQuebraLinha(getStatusPedido(p)) }}
          </button>
        </div>

        <div class="pea-card-corpo">
          <dl>
            <div>
              <dt><i class="bi bi-calendar3"></i> Realizado em</dt>
              <dd>{{ p.data }}</dd>
            </div>
            <div>
              <dt><i class="bi bi-credit-card"></i> Pagamento</dt>
              <dd>{{ getPagamento(p) }}</dd>
            </div>
            <div>
              <dt><i class="bi bi-geo-alt"></i> Enviar para</dt>
              <dd>{{ getDestino(p) }}</dd>
            </div>
            <div>
              <dt>Total · {{ getQtdItens(p) }} itens</dt>
              <dd class="pea-total">{{ formatValor(p.total) }}</dd>
            </div>
          </dl>
          <div class="pea-acoes">
            <button type="button" (click)="showPedidoFinalizado(p)">
              <i class="bi bi-info-circle"></i> Informações
            </button>
             <!-- <button *ngIf="p.status_pagamento === 'pendente'" type="button" (click)="gerarLinkPagamento(p)">
              <i class="bi bi-info-circle"></i>Pagar
            </button> -->
            <button type="button" (click)="redirectToRastreio(p)">
              <i class="bi bi-truck"></i> Rastreio
            </button>
            <button type="button" (click)="showPedido(p)">
              <i class="bi bi-eye"></i> Visualizar
            </button>
            <button type="button" (click)="showNotaFiscal(p)">
              <i class="bi bi-file-earmark-text"></i> Nota Fiscal
            </button>
            <button
              *ngIf="podePagar(p)"
              type="button"
              class="pea-pagar"
              (click)="abrirPagamento(p)"
            >
              <i class="bi bi-credit-card"></i> Pagar
            </button>
          </div>
        </div>
      </article>
    </div>

    <div class="pea-pagina" *ngIf="totalPages > 1 && !loading">
      <button type="button" [disabled]="page === 1" (click)="loadPedidos(1)">«</button>
      <button type="button" [disabled]="page === 1" (click)="loadPedidos(page - 1)">‹</button>
      <button
        type="button"
        *ngFor="let n of visiblePages"
        [class.ativo]="n === page"
        (click)="loadPedidos(n)"
      >
        {{ n }}
      </button>
      <button type="button" [disabled]="page >= totalPages" (click)="loadPedidos(page + 1)">›</button>
      <button type="button" [disabled]="page >= totalPages" (click)="loadPedidos(totalPages)">»</button>
    </div>
  </div>
</section>

<div
  class="pea-view"
  *ngIf="visualizando"
  [style.--pea-primary]="primaryColor"
  (click)="fecharVisualizacao()"
>
  <div class="pea-view-card" (click)="$event.stopPropagation()">
    <header class="pea-view-head">
      <p>Detalhes do pedido</p>
      <button
        type="button"
        class="pea-pay-close"
        (click)="fecharVisualizacao()"
        aria-label="Fechar"
      >
        ×
      </button>
    </header>

    <div class="pea-view-body">
      <div class="pea-view-grid">
        <div class="pea-view-campo">
          <small>Cliente</small>
          <strong>{{ getClienteNome(visualizando) }}</strong>
          <em *ngIf="getClienteCnpj(visualizando)">{{ getClienteCnpj(visualizando) }}</em>
        </div>
        <div class="pea-view-campo">
          <small>Empresa</small>
          <strong>{{ getEmpresaNome(visualizando) }}</strong>
          <em *ngIf="getEmpresaSub(visualizando)">{{ getEmpresaSub(visualizando) }}</em>
        </div>
        <div class="pea-view-campo">
          <small>Tabela de preço</small>
          <strong>{{ getTabelaPreco(visualizando) }}</strong>
        </div>
        <div class="pea-view-campo">
          <small>Data</small>
          <strong>{{ visualizando.data || "—" }}</strong>
        </div>
        <div class="pea-view-campo">
          <small>Data Entrega</small>
          <strong>{{ getDataEntrega(visualizando) }}</strong>
        </div>
        <div class="pea-view-campo">
          <small>Status</small>
          <span class="pea-status" [ngClass]="classeStatus(getStatusPedido(visualizando))">
            {{ statusQuebraLinha(getStatusPedido(visualizando)) }}
          </span>
        </div>
      </div>

      <div class="pea-view-grid">
        <div class="pea-view-campo">
          <small>Tipo</small>
          <strong>{{ getTipoPedido(visualizando) }}</strong>
        </div>
        <div class="pea-view-campo">
          <small>Desconto Percentual</small>
          <strong>{{ getDescontoPercent(visualizando) }}</strong>
        </div>
        <div class="pea-view-campo">
          <small>Pedido Origem</small>
          <strong>{{ getPedidoOrigem(visualizando) }}</strong>
        </div>
        <div class="pea-view-campo">
          <small>Quantidade</small>
          <strong>{{ getQtdItens(visualizando) }}</strong>
        </div>
        <div class="pea-view-campo">
          <small>Forma pagamento</small>
          <strong>{{ getFormaPagamentoCompleta(visualizando) }}</strong>
        </div>
        <div class="pea-view-totais">
          <p>Subtotal: <strong>{{ formatValor(getSubtotal(visualizando)) }}</strong></p>
          <p class="pea-view-imposto">
            + Impostos: <strong>{{ formatValor(getImpostos(visualizando)) }}</strong>
          </p>
           <p class="pea-view-frete">
            + Frete: <strong>{{ formatValor(getFreteValor(visualizando)) }}</strong>
          </p>
          <p class="pea-view-total">
            Valor total: <strong>{{ formatValor(visualizando.total) }}</strong>
          </p>
        </div>
      </div>

      <div class="pea-view-itens" *ngIf="itensVisualizacao.length">
        <article *ngFor="let grupo of itensVisualizacao" class="pea-view-item">
          <p>{{ tituloItemGrupo(grupo) }}</p>
          <table>
            <thead>
              <tr>
                <th>Cor</th>
                <th>Tamanho</th>
                <th>Qtde</th>
                <th>Preço</th>
                <th class="pea-view-num">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of grupo.itens">
                <td>{{ corItem(item) }}</td>
                <td>{{ tamanhoItem(item) }}</td>
                <td>{{ item.quantidade }}</td>
                <td>{{ formatValor(item.preco) }}</td>
                <td class="pea-view-num">{{ formatValor(totalItem(item)) }}</td>
              </tr>
              <tr class="pea-view-soma">
                <td colspan="2"></td>
                <td>{{ somaQtd(grupo.itens) }}</td>
                <td></td>
                <td class="pea-view-num">{{ formatValor(somaTotal(grupo.itens)) }}</td>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="notaFiscalModalAndamento" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Nota Fiscal</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="pedido">
        <div *ngIf="loadNota" class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
        </div>
        <div *ngIf="!loadNota && pedido.documentos && pedido.documentos.length > 0">
          <div class="pea-doc" *ngFor="let doc of pedido.documentos">
            <div>
              <p><strong>Nota:</strong> {{ doc.numero_nota }}</p>
              <p><strong>Tipo:</strong> {{ doc.tipo?.toUpperCase() }}</p>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="printNota(doc)">
              <span *ngIf="doc.tipo?.toUpperCase() === 'DANFE'">Visualizar DANFE</span>
              <span *ngIf="doc.tipo?.toUpperCase() !== 'DANFE'">Download XML</span>
            </button>
          </div>
        </div>
        <div
          *ngIf="!loadNota && (!pedido.documentos || pedido.documentos.length === 0)"
          class="alert alert-info"
        >
          Nenhum documento disponível para este pedido.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>

<app-pagamento-pedido
  *ngIf="pagando"
  [pedido]="pagando"
  [primaryColor]="primaryColor"
  (fechar)="fecharPagamento()"
></app-pagamento-pedido>

<div class="modal fade" id="pedidoModalInfoAndamento" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div *ngIf="pedido" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Pedido #{{ pedido.pedido || pedido.numero_pedido || pedido.id }} - Informações</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="pedido.infos?.length">
        <div class="row mt-2">
          <div class="col-sm-4">
            <label>Id ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].idErp }}
          </div>
          <div class="col-sm-8">
            <label>Código ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].codigoErp }}
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div class="col-sm-4">
            <label>NFS</label><br />
            {{ pedido.infos[pedido.infos.length - 1].nfs }}
          </div>
          <div class="col-sm-8">
            <label>Chave NFE</label><br />
            {{ pedido.infos[pedido.infos.length - 1].chaveNfe }}
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div class="col-sm-4">
            <label>Status</label><br />
            {{ pedido.infos[pedido.infos.length - 1].statusDescricao }}
          </div>
          <div class="col-sm-8">
            <label>Número Objeto</label><br />
            {{ pedido.infos[pedido.infos.length - 1].numeroObjeto }}
          </div>
        </div>
        <div class="table-responsive mt-3">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Data</th>
                <th>Status</th>
                <th>NFS</th>
                <th>Chave NFE</th>
                <th>Número Objeto</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let info of pedido.infos">
                <td>{{ info.data }}</td>
                <td>{{ info.statusDescricao }}</td>
                <td>{{ info.nfs }}</td>
                <td>{{ info.chaveNfe }}</td>
                <td>{{ info.numeroObjeto }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
